import {
  DragResult,
  SortableList,
} from '@tribeplatform/react-ui-kit/SortableList'

import {
  FieldSortableItem,
  FieldSortableItemVariant,
} from './FieldSortableItem.js'

interface GeneralItem {
  id: string
  label: string
  icon?: JSX.Element
  enabled: boolean
  disabled?: boolean
  isPrivate?: boolean
  isLocked?: boolean
  tooltip?: string
  tooltipIcon?: JSX.Element
  draggable?: boolean
}
interface FieldsSortableListProps<T> {
  items: T[]
  disabled?: boolean
  hasArrow?: boolean
  variant?: FieldSortableItemVariant
  renderDropDownItems?: (id: string) => JSX.Element
  onReorder: (newItems: T[]) => void
  onClick?: (id: string) => void
  onActivate?: (id: string) => void
  onToggle: (id: string) => void
}
type FieldsSortableListType = <T extends GeneralItem>(
  props: FieldsSortableListProps<T>,
) => JSX.Element
export const FieldsSortableList: FieldsSortableListType = ({
  items,
  disabled,
  hasArrow,
  variant,
  renderDropDownItems,
  onReorder,
  onClick,
  onActivate,
  onToggle,
}) => {
  const onDragEnd = (result: DragResult) => {
    if (!result.destination) {
      return
    }
    const newItems = SortableList.reorder(
      items,
      result.source.index,
      result.destination.index,
    )

    onReorder(newItems)
  }

  return (
    <SortableList
      onDragEnd={onDragEnd}
      items={items}
      disabled={disabled}
      renderItem={({
        id,
        label,
        icon,
        enabled,
        isPrivate,
        isLocked,
        tooltip,
        tooltipIcon,
        disabled: itemDisabled,
        draggable = true,
      }) => (
        <SortableList.Item id={id}>
          <FieldSortableItem
            id={id}
            label={label}
            icon={icon}
            onClick={onClick}
            onActivate={onActivate}
            onToggle={onToggle}
            enabled={enabled}
            disabled={disabled || itemDisabled}
            hasArrow={hasArrow}
            variant={variant}
            isPrivate={isPrivate}
            isLocked={isLocked}
            tooltip={tooltip}
            tooltipIcon={tooltipIcon}
            dropDownItems={renderDropDownItems?.(id)}
            draggable={draggable}
          />
        </SortableList.Item>
      )}
    />
  )
}
